/**
 * @tanstack/react-query hook for the self-service "My Profile" read
 * (UX-21). Thin wrapper over lib/api/me-profile.ts.
 *
 * Query-key convention: ["me-profile"]. Self-scoped, so no params — the
 * server returns the caller's own row.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMyProfile,
  updateMyProfile,
  type UpdateMyProfileInput,
} from "@/lib/api/me-profile";

export const meProfileKeys = {
  all: ["me-profile"] as const,
};

export function useMyProfile() {
  return useQuery({
    queryKey: meProfileKeys.all,
    queryFn: ({ signal }) => getMyProfile(signal),
  });
}

/** Direct edit of the low-risk profile fields (phone, emergency contact). */
export function useUpdateMyProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateMyProfileInput) => updateMyProfile(body),
    onSuccess: (data) => {
      qc.setQueryData(meProfileKeys.all, data);
    },
  });
}
